<template>
  <div>
    <div
      v-if="!disabled"
      class="d-flex justify-content-end align-items-center mt-md-6 mt-7 mb-4"
    >
      <span class="text-dark-gray mr-1">
        リンクをコピー
      </span>
      <copy-link-icon 
        :page-path="companyPath"
        :buttonSize="28"
      />
    </div>
    <div class="d-flex align-items-center mb-10">
      <div 
        class="company-detail-logo d-flex justify-content-center align-items-center px-1 mr-md-4 mr-3"
      >
        <img
          id="logo"
          alt="Company Logo"
          :src="companyLogo === '' ? defaultImage : companyLogo"
          class="img-fit w-100 h-100"
        >
      </div>
      <div class="flex-1">
        <h1
          id="company-name"
          class="mb-2 bold"
        >
          {{ companyName }}
        </h1>
        <p
          id="business-categories"
          class="d-inline-block mb-0 text-dark-gray font-default"
        >
          {{ businessCategories.join("、 ") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CopyLinkIcon from "../../components/CopyLinkIcon.vue";
import "../../i18n/ja";
import { i18n } from "../../mixins/i18n";

export default {
  components: { CopyLinkIcon },
  mixins: [i18n],
  props: {
    companyName: {
      type: String,
      required: true
    },
    companyLogo: {
      type: String,
      default: ""
    },
    businessCategories: {
      type: Array,
      default() {
        return [];
      }
    },
    companyPath: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultImage: require("../../../../assets/images/no_logo.png"),
    };
  }
};
</script>

<style lang="scss" scoped>
h1 {
  &#company-name {
    font-size: 1.71428rem;
    line-height: 38.5px;
    @media (max-width: 767px) {
      font-size: 1.28571rem;
      line-height: 29px;
    }
  }
}
.company-detail-logo {
  width: 105px;
  height: 105px;
  @media (max-width: 767px) {
    width: 70px;
    height: 70px;
  }
}
</style>
